<template>
  <div
    class="base-input input__wrap"
    :class="{ error: hasValidationError && !loading }"
    :style="{ width }"
  >
    <label
      v-if="label"
      @click="() => !readonly && $refs.input.focus()"
      :class="['input__label', { readonly, disabled }]"
    >{{ label }}{{ required ? '*' : '' }}</label>

<!--    <svgicon v-if="icon" :icon="icon" width="20px" class="icon" />-->

    <input
      :autocomplete="autocomplete ? 'on' : 'off'"
      ref="input"
      :name="name"
      v-model="inputValue"
      :placeholder="readonly ? '-' : placeholder"
      class="input__field"
      :readonly="readonly"
      :disabled="disabled || loading"
      :maxlength="usedMask.mask.length || limitMaxLength"
      @blur="handleBlur"
      @focus="$emit('focus')"
      @keydown="keydown"
      @keyup="keyup"
      @keypress="keypress"
      @paste="paste"
      :style="icon ? 'padding-left: 37px' : null"
    />
    <img
      class="loader_img"
      v-if="serverValidationPending"
      src="/img/Loader.gif"
    />
    <slot v-if="hasValidationError && !serverValidationPending" />
  </div>
</template>

<script>
import Base from './Base/Base'

export default {
  name: 'vtext',
  extends: Base,
  props: {
    icon: String
  },
  methods: {
    handleBlur () {
      this.$emit('blur')
      this.validate()
    },
    focus () {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
.loader_img {
  width: 15px;
  position: absolute;
  bottom: 32%;
  right: 10px;
}

.icon {
  position: absolute;
  left: 12px;
  top: 13px;
}
</style>
